module.exports = __webpack_public_path__ + "static/media/edit_user_page.cd52edc2.PNG";